import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import type { VisibleInsets } from "@/hooks/useVisibleViewport";

const DEFAULT_VISIBLE_INSETS: VisibleInsets = {
  top: 0,
  bottom: 0,
  height: 0,
};

const VisibleViewportContext = createContext<VisibleInsets>(
  DEFAULT_VISIBLE_INSETS,
);

export const VisibleViewportProvider = ({
  value,
  children,
}: {
  value: VisibleInsets;
  children: ReactNode;
}) => (
  <VisibleViewportContext.Provider value={value}>
    {children}
  </VisibleViewportContext.Provider>
);

export const useVisibleViewportInsets = (): VisibleInsets =>
  useContext(VisibleViewportContext);
